module.exports = __webpack_public_path__ + "img/AccessDeniedError.8d47a63b.png";